import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=931dfb10&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=ts&"
export * from "./nav.vue?vue&type=script&lang=ts&"
import style0 from "./nav.vue?vue&type=style&index=0&id=931dfb10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931dfb10",
  null
  
)

export default component.exports